import './UpcomingWebinarsList.scss'

import { useRestoreScroll } from 'lib/util/scrollBehavior'
import RecordedWebinarType from 'pages/Home/RecordedWebinarType'
import UpcomingWebinarType from 'pages/Home/UpcomingWebinarType'
import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import UpcomingWebinar from './UpcomingWebinar'

export interface UpcomingWebinarsListProps extends RouteComponentProps {
  recordedWebinars: RecordedWebinarType[]
  renderSeriesLink?: boolean
  upcomingWebinars: UpcomingWebinarType[]
}

export default withRouter(function UpcomingWebinarsList(props: UpcomingWebinarsListProps) {
  const { history, location, recordedWebinars, renderSeriesLink, upcomingWebinars } = props
  useRestoreScroll(history, location)

  return (
    <ul className="upcoming-webinars-list">
      {upcomingWebinars.map(upcomingWebinar => (
        <UpcomingWebinar
          key={upcomingWebinar.id}
          recordedWebinars={recordedWebinars}
          renderSeriesLink={renderSeriesLink}
          upcomingWebinar={upcomingWebinar}
        />
      ))}
    </ul>
  )
})
